import React from 'react';

import { Flex, LssProp, Text } from '@lucidhq/lucidium';

import { ROUTES } from '~/constants';
import { BasePage } from '~/impact-measurement/components';
import { AdminNavBar } from '~/impact-measurement/pages/Admin';
import { t } from '~/utils/i18n';

import { useErrorDialogProvider } from '../Shared/ErrorDialogProvider';
import { IDsTable } from './IDsTable/IDsTable';
import { IPManagementSection } from './IPManagementSection';
import { IPMatchingPagination } from './IPMatchingPagination';
import { useIPMatchingContext } from './IPMatchingProvider';
import { MatchedIDsHeader } from './MatchedIDsHeader';

const containerLss: LssProp = {
  flexDirection: 'column',
  mx: 'xxxl',
  minHeight: '25rem',
  pb: 'xxl',
  mb: 'xxl',
  gap: '1.25rem'
};

export const IPMatchingBasePage = () => {
  const { setError } = useErrorDialogProvider();
  const {
    isLoadingIPMatching,
    campaign,
    matchedIds,
    error,
    campaignError
  } = useIPMatchingContext();

  if (error || campaignError) {
    setError(t('errors.generalApiError'));
  }

  return (
    <BasePage isFluid hasFooter={false}>
      {/* NOTE: need to add client-name to campaign in order to display in-target brand correctly */}
      <AdminNavBar
        showBackButton
        campaign={campaign}
        isLoading={isLoadingIPMatching}
        isReview={false}
        backToPath={ROUTES.adminCampaigns}
        navBarLss={{
          top: '0',
          position: 'unset',
          tablet: { position: 'unset', paddingLeft: 0 }
        }}
      />
      <Flex lss={containerLss}>
        <Text
          as="h3"
          lss={{ fontWeight: 'bold', lineHeight: '40px', fontSize: '2rem' }}
        >
          {t('ipMatching.pageHeader')}
        </Text>
        <IPManagementSection />
        <MatchedIDsHeader
          title={t('ipMatching.matchedIdsHeader.title')}
          description={t('ipMatching.matchedIdsHeader.description')}
          matchedIds={matchedIds}
        />
        <IDsTable />
        <IPMatchingPagination />
      </Flex>
    </BasePage>
  );
};
